import IEventCategory from 'interfaces/IEventCategory';
import RestService from './RestService';

export default class EventCategoryService extends RestService<IEventCategory> {
  constructor() {
    super('event-categories');
  }
}
